import _ from 'lodash';
import { type Dispatch, type SetStateAction, useState } from 'react';
import type { Bookmark } from '@/types/bookmarks';
import type { Routes } from '../../utils/parseRouteName';
import { BookmarkCard } from './BookmarkCard';
import { BookmarkMenu } from './BookmarkMenu';
import { NoResult } from './NoResult';
import { type Dir, type Sort, SortButtons, type SortParameter } from './SortButtons';

export const Content = ({
  activeBookmark,
  bookmarks,
  section,
  setSection,
}: {
  activeBookmark: Bookmark | null;
  bookmarks: Bookmark[];
  section: Routes | null;
  setSection: Dispatch<SetStateAction<Routes | null>>;
}) => {
  const [editId, setEditId] = useState<number | null>(null);
  const [sort, setSort] = useState<Sort>('viewed_count:desc');
  const [sortParameter, sortDirection] = sort.split(':') as [SortParameter, Dir];

  return (
    <div className='min-w-full space-y-2 p-4'>
      <div className='flex flex-1 justify-end gap-4 pb-2'>
        <SortButtons
          sort={sort}
          setSort={setSort}
        />
      </div>
      <div className='flex'>
        <BookmarkMenu
          section={section}
          setSection={setSection}
        />
        <div className='scrollbar h-96 w-full space-y-4 overflow-y-auto pr-2'>
          {bookmarks.length === 0 && !activeBookmark && <NoResult />}
          {!!activeBookmark && (
            <BookmarkCard
              bookmark={activeBookmark}
              editId={editId}
              setEditId={setEditId}
              isActive
            />
          )}
          {_.orderBy(bookmarks, [sortParameter], [sortDirection]).map((bookmark) => (
            <BookmarkCard
              key={bookmark.id}
              editId={editId}
              setEditId={setEditId}
              bookmark={bookmark}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
